export const NO_LOCATION_NAME = 'no_location_name';
